<template>
  <div>
    <div v-for="mag in mags">
      <mag
        :mag="mag"
        :user="users[mag.user_id]"
        :show-edit="(currentUser && currentUser.key === users[mag.user_id].key) || isProfilePage"
        :already-liked="likedMagKeys.includes(mag.key)" />
      <hr />
    </div>
    <infinite-loading @infinite="infinite">
      <div slot="spinner">読み込み中...</div>
      <div slot="no-more">まぐわいはもうありません</div>
      <div slot="no-results">まぐわいは存在しません</div>
    </infinite-loading>
  </div>
</template>

<script>
import apiAgent from '../common/api_agent'
import Mag from './_mag'
import InfiniteLoading from 'vue-infinite-loading'

export default {
  components: { Mag, InfiniteLoading },
  props: ['currentUser', 'isProfilePage', 'targetUserIds', 'newMag'],
  data() {
    return { mags: [], users: {}, page: 1, likedMagKeys: [] }
  },
  mounted() {
  },
  methods: {
    async fetchMags() {
      const data = { page: this.page, already_fetched_user_ids: Object.keys(this.users) }
      if (this.targetUserIds) {
        data.target_user_ids = this.targetUserIds
      }
      const response = await apiAgent({
        url: this.isProfilePage ? '/api/mags/profile' : '/api/mags',
        method: 'GET',
        data: data
      });
      const json = await response.json()
      this.users = Object.assign({}, this.users, json.users)
      this.mags = this.mags.filter(mag => !json.mags.find(jsonMag => jsonMag.key == mag.key)).concat(json.mags)
      this.likedMagKeys = json.current_foot_stamp.liked_mag_keys
      this.page = this.page + 1
      return json.mags.length !== 0
    },
    async infinite($state) {
      const resultExists = await this.fetchMags()

      if(resultExists) {
        $state.loaded()
      } else {
        $state.complete()
      }
    }
  },
  watch: {
    newMag(newMag) {
      if (!newMag) { return }

      this.mags = [newMag].concat(this.mags.filter(mag => mag.key != newMag.key))
    }
  }
}
</script>

<style scoped>
</style>
